import { Link } from "react-router-dom";
import { CoverImg } from "@/components/ui/CoverImg";
import { IconHeart, IconHeartFilled } from "@/components/ui/icons";
import { Marquee } from "@/components/ui/Marquee";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useLibrary } from "@/hooks/useLibrary";
import { usePlayer } from "@/hooks/usePlayer";

export function NowPlaying() {
  const { current } = usePlayer();
  const { isLiked, toggle } = useLibrary();
  const isMobile = useIsMobile(800);
  if (!current) return <div style={{ width: isMobile ? 0 : 260 }} />;
  const liked = isLiked("track", current.id);
  const cover = isMobile ? 40 : 56;
  return (
    <div className="row" style={{
      minWidth: 0,
      gap: isMobile ? 10 : 10,
      overflow: "hidden",
      justifyContent: "flex-start",
    }}>
      <CoverImg coverId={current.album?.cover_id} alt={current.title} size={cover} />
      {/* Meta capped so it doesn't stretch and shove the heart to the edge.
          Marquee kicks in for titles/artists that overflow the cap. */}
      <div style={{
        minWidth: 0,
        maxWidth: isMobile ? undefined : 220,
        flex: isMobile ? 1 : "0 1 auto",
      }}>
        <Marquee style={{ fontWeight: 600, fontSize: isMobile ? 13 : 14 }}>
          {current.title}
        </Marquee>
        <Link
          to={`/artist/${current.artist.id}`}
          className="muted"
          style={{ display: "block", fontSize: isMobile ? 12 : 13 }}
        >
          <Marquee>{current.artist.name}</Marquee>
        </Link>
      </div>
      {!isMobile && (
        <button
          onClick={() => void toggle("track", current.id)}
          title={liked ? "Retirer des likés" : "Ajouter aux likés"}
          style={{ flexShrink: 0, marginLeft: 2 }}
        >
          {liked ? <IconHeartFilled /> : <IconHeart />}
        </button>
      )}
    </div>
  );
}
